<template>
  <div>
    <p>A constellation orbit can be defined by specifying:</p>
    <ul>
      <li>Orbit altitude and inclination</li>
      <li>Orbit altitude and Sun-Synchronicity</li>
      <li>
        Phasing triplet <katex-element expression="(N,\:P,\:Q)" /> with
        additional Sun-Synchronicity
      </li>
      <li>
        Phasing triplet <katex-element expression="(N,\:P,\:Q)" /> and
        inclination
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationGeometrySpacecraft'
}
</script>
